import type { OrderLineItem, ReturnRequest } from "../types";

export function filterReturnableItems(
  lineItems: OrderLineItem[],
  returnRequests: ReturnRequest[],
): OrderLineItem[] {
  const returnedQuantities = buildReturnedQuantityMap(returnRequests);

  return lineItems.filter((lineItem) => {
    const returned = returnedQuantities.get(lineItem.line_item_id) ?? 0;
    return (lineItem.quantity_bought ?? 0) > returned;
  });
}

function buildReturnedQuantityMap(
  returnRequests: ReturnRequest[],
): Map<string, number> {
  const map = new Map<string, number>();

  for (const rr of returnRequests) {
    for (const li of rr.line_items) {
      if ((li.quantity ?? 0) > 0) {
        map.set(li.line_item_id, (map.get(li.line_item_id) ?? 0) + li.quantity);
      }
    }
  }

  return map;
}
